// Module
var code = "<td class=\"timewriting-table-column__value dash\" data-bind=\"visible: _cell.Visible\"> - </td>";
// Exports
export default code;